module.exports = __webpack_public_path__ + "img/5.ec3eb0a8.jpg";